import type { ReactNode } from "react";
import "./DateButton.scss";
import type { DateStyle } from "@/shared/utils/Dates.ts";
import type { IconComponent } from "@/shared/components/generic/IconComponentType.ts";
import useDateFormatter from "@/shared/custom-hook/useDateFormatter.ts";
import { colors } from "@/shared/style/design_system/Colors.ts";

interface Properties {
  value: Date | undefined;
  timeZone: string;
  dateStyle: DateStyle;
  icon: IconComponent;
  onClick: () => void;
}

export default function DateButton(props: Properties): ReactNode {
  const { formatDate } = useDateFormatter(props.timeZone);
  return (
    <div className="date-button" onClick={props.onClick}>
      <div className="date-label">
        {props.value !== undefined && formatDate(props.value, props.dateStyle)}
      </div>
      <div className="date-button-icon">
        {props.icon({ color: colors.foam500, width: "16px", height: "16px" })}
      </div>
    </div>
  );
}
